import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { V_IOTBOX_DEV_LIST, GetIoTBoxErrorList, IotBoxAlarmData } from './IoTDevList';

import { IoTDevListStyle, TableUseStyle } from './IoTDevListStyle';
type IotDevListHealthyErrorListDialogProps = {
  open: boolean;
  onClose: () => void;
  iotBoxData: V_IOTBOX_DEV_LIST;
};

const IotDevListHealthyErrorListDialog: React.FC<IotDevListHealthyErrorListDialogProps> = (props) => {
  const tableStyle = TableUseStyle();
  const pageStyle = IoTDevListStyle();
  const { t } = useTranslation();
  const [iotBoxAlarmDataList, setIoTBoxAlarmDataList] = useState<IotBoxAlarmData[]>([]);
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);

  useEffect(() => {
    if (props.open === true) {
      setButtonEnable(false);
      console.debug(['IotDevListHealthyErrorListDialog useEffect']);
      GetIoTBoxErrorList(props.iotBoxData.IMSI_NO)
        .then((r) => {
          setIoTBoxAlarmDataList(r);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setButtonEnable(true);
        });
    } else {
      setIoTBoxAlarmDataList([]);
    }
  }, [props.open]);

  /**
   * エラー区分
   * @param sate
   * @returns
   */
  const getAlmKindText = (kind: Number): string => {
    if (kind == undefined) return t('IotDevListHealthyErrorListDialog.不明', '不明');
    switch (kind) {
      case 1:
        return t('IotDevListHealthyErrorListDialog.重故障', '重故障');
      case 2:
        return t('IotDevListHealthyErrorListDialog.軽故障', '軽故障');
      case 3:
        return t('IotDevListHealthyErrorListDialog.システム異常', 'システム異常');
      default:
        return t('IotDevListHealthyErrorListDialog.不明', '不明');
    }
  };
  return (
    <Dialog open={props.open} fullWidth={true} maxWidth={'md'}>
      <DialogTitle id="alert-dialog-title">
        {t('IotDevListHealthyErrorListDialog.TMBee-Boxアラームログ', 'TMBee-Boxアラームログ')}
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} className={pageStyle.tableContainer}>
          <Table stickyHeader aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell className={tableStyle.headerCell}>
                  {t('IotDevListHealthyErrorListDialog.項目名', '項目名')}
                </TableCell>
                <TableCell className={tableStyle.headerCell}>
                  {' '}
                  {t('IotDevListHealthyErrorListDialog.区分', '区分')}
                </TableCell>
                <TableCell className={tableStyle.headerCell}>
                  {t('IotDevListHealthyErrorListDialog.アラームコード', 'アラームコード')}
                </TableCell>
                <TableCell className={tableStyle.headerCell}>
                  {t('IotDevListHealthyErrorListDialog.アラーム内容', 'アラーム内容')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {iotBoxAlarmDataList.map((row, index) => {
                return (
                  <TableRow hover key={index}>
                    <TableCell className={tableStyle.bodyCell}>{row.ALM_SMM_DAT.ITM_NAME}</TableCell>
                    <TableCell className={tableStyle.bodyCell}>{getAlmKindText(row.ALM_SMM_DAT.ALM_KIND)}</TableCell>
                    <TableCell className={tableStyle.bodyCell}>{row.ALM_SMM_DAT.ALM_CODE}</TableCell>
                    <TableCell className={tableStyle.bodyCell}>{row.ALM_SMM_DAT.MESSAGE}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          disabled={!buttonEnable}
          disableElevation
          onClick={() => {
            props.onClose();
          }}
        >
          {t('IotDevListHealthyErrorListDialog.閉じる', '閉じる')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default IotDevListHealthyErrorListDialog;
